import { useLocation, Outlet, Navigate } from "react-router-dom";
import { TUserRole } from "../../transports/user";
import { useAuth } from "../../utils/useAuth";

const RequiredRole: React.FC<{ allowedRoles: TUserRole[] | "ALL" | "" }> = ({ allowedRoles }) => {
    const { currentUser } = useAuth();
    const location = useLocation;

    return (
        <>
            {currentUser?.role != undefined &&
            (allowedRoles == "ALL" || allowedRoles.includes(currentUser?.role)) ? (
                <Outlet />
            ) : (
                <Navigate to="/" state={{ from: location }} />
            )}
        </>
    );
};
export default RequiredRole;
